"use client";

import { useState, ReactNode } from 'react';
import Sidebar from './Sidebar';
import { FiMenu } from 'react-icons/fi';
import NotificationBell from '../notifications/NotificationBell';

interface AdminLayoutProps {
  children: ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-900 text-gray-100">
      {/* Sidebar for larger screens */}
      <div className="hidden md:flex">
        <Sidebar />
      </div>

      {/* Mobile Sidebar */}
      {isSidebarOpen && (
        <div className="fixed inset-0 z-30 flex md:hidden">
          <Sidebar />
          <div
            className="flex-1 bg-black opacity-50"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
        </div>
      )}

      <div className="flex flex-1 flex-col">
        {/* Desktop Header */}
        <header className="hidden md:flex items-center justify-between bg-gray-800 p-4 border-b border-gray-700">
          <h1 className="text-xl font-bold">管理系統</h1>
          <div className="flex items-center space-x-4">
            <NotificationBell />
            {/* Admin user info can be added here if available in context */}
          </div>
        </header>

        {/* Mobile Header */}
        <header className="flex items-center justify-between bg-gray-800 p-4 md:hidden">
          <h1 className="text-xl font-bold">管理系統</h1>
          <button onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <FiMenu className="h-6 w-6" />
          </button>
        </header>

        {/* Main Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
}
